export default __webpack_public_path__ + "static/media/GettyImages-533978201-581033c95f9b58564c992794.bd3c0c4a.webp";